import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { Observable } from 'rxjs';
import {
  FormState,
  IntegrationsFormService,
} from 'src/app/settings/user-settings-panel/user-settings-integrations/services/integrations-form.service';
import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';

@Component({
  selector: 'app-side-nav-layout',
  templateUrl: './side-nav-layout.component.html',
  styleUrls: ['./side-nav-layout.component.scss'],
})
export class SideNavLayoutComponent implements OnChanges {
  @Input() sidenavTitle!: string;
  @Input() menu!: MatMenu;
  @Input() isFormMode = false;
  @Input() showFooter = false;
  @Input() primaryBtnIcon = 'check';
  @Input() primaryBtnLabel = '';
  @Input() secondaryBtnIcon = 'close';
  @Input() secondaryBtnLabel = '';
  @Input() showSecondaryButton = true;

  @Output() sidenavClosed = new EventEmitter<void>();
  @Output() primaryBtnClicked = new EventEmitter<void>();
  @Output() secondaryBtnClicked = new EventEmitter<void>();

  @ViewChild('sidenav') sidenav!: MatSidenav;

  readonly IconTypes = IconTypes;
  readonly FormState = FormState;

  formState$?: Observable<FormState>;

  constructor(private readonly integrationsFormService: IntegrationsFormService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isFormMode) {
      this.formState$ = this.isFormMode ? this.integrationsFormService.getFormState$() : undefined;
    }
  }

  public open(): void {
    this.sidenav.open();
  }

  public close(): void {
    this.sidenav.close();
    this.sidenavClosed.emit();
  }

  onPrimaryBtnClick(): void {
    this.primaryBtnClicked.emit();
  }

  onSecondaryBtnClick(): void {
    this.secondaryBtnClicked.observed ? this.secondaryBtnClicked.emit() : this.close();
  }
}
